
import React, { useEffect, useState } from "react";
import './tableStyle.css';

export declare type InputProps = {
    currentPage: number,
    lastPage: number,
    onChange?: (type: string) => any,
}


export const TablePagination = ({ currentPage, lastPage, onChange }: InputProps) => {

    const handelChange = (type: string) => {
        onChange?.(type)
    }

    return (
        <>
            {currentPage != 1 &&
                <div className="w-[60px] h-[40px] cursor-pointer text-sm shadow mx-2 bg-dayan-gray-200 rounded-md flex justify-center items-center text-white" onClick={() => handelChange('before')} >
                    قبلی
                </div>
            }
            {lastPage >= currentPage + 1 &&
                <div className="w-[40px] h-[40px]  shadow mx-2 bg-gray-400 rounded-md flex justify-center items-center text-dayan-gray-200">{currentPage} </div>
            }
            {lastPage >= currentPage + 2 &&
                <div className="w-[40px] h-[40px]  shadow mx-2 bg-white rounded-md flex justify-center items-center text-dayan-gray-200 cursor-pointer" onClick={() => handelChange('next')}>{currentPage + 1} </div>
            }
            {lastPage >= currentPage + 1 &&
                <div className="w-[80px] h-[40px] cursor-pointer text-sm shadow mx-2 bg-dayan-gray-200 rounded-md flex justify-center items-center text-white" onClick={() => handelChange('next')} >
                    بعدی
                </div>
            }
        </>
    )
}
